import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { api } from "../../redux/apis/api";
import { FormDropDown } from "../../components/form/dropdown";
import { useState } from "react";
import { useEffect } from "react";
import { FormTextAreaField } from "../../components/form/text-area";
import SubmitModal from "../../components/modal/submit-modal";

const EditEmployeeRequest = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [customerlist, setcustomerlist] = useState([]);
  const [addresslist, setAddresslist] = useState([]);
  const [showSubmit, setshowSubmit] = useState(false);
  const [showSubmitModal, setshowSubmitModal] = useState(false);

  const initialValues = {
    id: data?.id ?? null,
    customer_id: data?.customer_id ?? null,
    customer_delivery_address: data?.customer_delivery_address ?? null,
    status: data?.status ?? "",
    description: data?.description ?? "",
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/employee-request/edit`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        setshowSubmit(true);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const UpdateStatusFnc = () => {
    var status = {
      id: params?.id,
      status: "submitted",
    };

    api
      .post(`/employee-request/update-status`, status)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/employee-request/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/employee-request/view`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const fetchCustomerDropDownData = () => {
    api
      .get(`/customer/dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.customers?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setcustomerlist(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchaddressDropDownData = (customer_id) => {
    api
      .post(`/employee-request/customer-address-dropdown`, { customer_id })
      .then((res) => {
        let newArr = res?.data?.data?.addresses?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setAddresslist(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchData();
    fetchCustomerDropDownData();
  }, []);

  useEffect(() => {
    if (data?.customer_id) {
      fetchaddressDropDownData(data?.customer_id);
    }
  }, [data?.customer_id]);

  return (
    <MainLayout>
      <SubmitModal
        isOpen={showSubmitModal}
        onClose={() => setshowSubmitModal(false)}
        btnFnc={UpdateStatusFnc}
      />
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Employee Request - Edit
                </h2>

                {showSubmit ? (
                  <div className="flex gap-3 items-center">
                    <button
                      onClick={() => naviagte("/employee-request/list")}
                      type="button"
                      className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => setshowSubmitModal(true)}
                      className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                    >
                      Submit
                    </button>
                  </div>
                ) : (
                  <div className="flex gap-3 items-center">
                    <button
                      onClick={() => naviagte("/employee-request/list")}
                      type="button"
                      className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                    >
                      Cancel
                    </button>
                    {data?.status === "draft" && (
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    )}
                  </div>
                )}
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormDropDown
                    name="customer_id"
                    label="customer"
                    options={customerlist}
                    onChangeExtra={(customerId) => {
                      if (customerId) {
                        fetchaddressDropDownData(customerId);
                      }
                    }}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="customer_delivery_address"
                    label="customer delivery address"
                    options={addresslist}
                  />
                </div>

                {values?.customer_delivery_address && values?.customer_id ? (
                  <div className="mb-6">
                    <div className="flex  items-center gap-3">
                      <p>Customer name :</p>
                      <div>
                        {
                          customerlist?.find(
                            (item) => item?.value === values?.customer_id
                          )?.label
                        }
                      </div>
                    </div>
                    <div className="flex  items-center gap-3">
                      <p>Customer delivery address:</p>
                      <div>
                        {
                          addresslist?.find(
                            (item) =>
                              item?.value === values?.customer_delivery_address
                          )?.label
                        }
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="my-4">
                  <FormTextAreaField
                    name={"description"}
                    label={"description"}
                    placeholder={`Enter description`}
                    rows={3}
                  />
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditEmployeeRequest;
